import React from "react";
import { useEffect, useState } from "react";
import {getTermsAndConditionsHTML} from "../../shared/services/http/UsuarioService"

export default function TermosCondicoesText() {

  const [html, setHtml] = useState("")

  useEffect(() => getTextHTML(), [])

  function getTextHTML() {
    getTermsAndConditionsHTML()
      .then(result => {
        setHtml(result)
      })
  }

  return(
    <>
      {
        <div dangerouslySetInnerHTML={{__html: html}}></div>
      }
    </>
  )
}
